<template>
	<div class="pages" :style="{ height: height + 'px' }">
		<navTop></navTop>
		<div class="box">
			<div class="box-main">
				<div class="box-main-reason">
					<div class="box-main-reason-left">Please select refund reason</div>
					<select class="box-main-reason-right" @change="fnselect($event)">
						<option v-for="(item, index) in cancelList" :key="index">
							{{ item.name }}
						</option>
					</select>
				</div>
				<p class="box-main-explain">Explain</p>
				<textarea
					class="box-main-textarea"
					v-model="content"
					placeholder="请输入更多原因"
				></textarea>
				<div class="box-main-btn" @click="subimt">Determine</div>
			</div>
		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
export default {
	name: 'applyRefund',
	components: {
		navTop
	},
	data() {
		return {
			height: '',
			content: '',
			text: '',
			cancelList: [],
			id: ''
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.height = window.innerHeight;
			this.id = this.$route.query.id;
			this.getCancelreason();
		}
	},
	methods: {
		getCancelreason() {
			let data = {
				type: 1
			};
			this.$api.cancelreason(data).then(res => {
				console.log(res);
				if (res.result == 0) {
					this.cancelList = res.dataList;
					this.text = res.dataList[0].name;
				}
			});
		},
		fnselect(e) {
			this.text = e.target.value;
		},
		subimt() {
			if (this.content == '') {
				this.$message({
					message: 'Please fill in the after-sales reasons',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			let data = {
				id: this.id,
				type: 0,
				cancelReason: this.text,
				cancelDetail: this.content
			};
			this.$api.cancel(data).then(res => {
				console.log(res);
				if (res.result == 0) {
					this.$router.push({ path: '/success', query: { num: 3 } });
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	.box {
		padding-top: 64px;
		box-sizing: border-box;
		.box-main {
			width: 100%;
			border-radius: 38px;
			background-image: url(../../assets/cancel.png);
			background-size: 100% 100%;
			padding: 77px 200px 139px;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			.box-main-reason {
				display: flex;
				align-items: center;
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				.box-main-reason-left {
					font-size: 24px;
					color: #00fff0;
					line-height: 1em;
				}
				.box-main-reason-right {
					outline: none;
					margin-left: 33px;
					width: 466px;
					height: 50px;
					background: rgba(35, 254, 246, 0.1);
					border: 1px solid #48ece7;
					padding: 0 20px;
					box-sizing: border-box;
					font-weight: 400;
					color: #13fffc;
					line-height: 1em;
					option {
						background: #000;
						color: #00d9dd;
					}
				}
			}
			.box-main-explain {
				width: 100%;
				font-size: 24px;
				color: #00fff0;
				line-height: 1em;
				margin-top: 42px;
				text-align: center;
			}
			.box-main-textarea {
				margin-top: 30px;
				width: 100%;
				height: 159px;
				background: rgba(35, 254, 246, 0.1);
				border: 1px solid #48ece7;
				outline: none;
				resize: none;
				padding: 17px 20px;
				box-sizing: border-box;
				font-size: 16px;
				font-weight: 400;
				color: #13fffc;
				line-height: 28px;
			}
			.box-main-textarea::-webkit-input-placeholder {
				color: #13fffc;
			}
			.box-main-btn {
				width: 100%;
				height: 60px;
				background: linear-gradient(
					90deg,
					rgba(29, 175, 170, 0.8) 0%,
					rgba(35, 254, 246, 0.8) 100%
				);
				font-size: 24px;
				font-family: Adobe Heiti Std;
				font-weight: normal;
				color: #f6f6f6;
				line-height: 60px;
				text-align: center;
				margin: 51px auto 0;
			}
		}
	}
}
</style>
